// Dependencies
import { FC } from "react";

// Components
import { GlobalStyles as MGlobalStyles } from "@mui/material";

// Themes
import theme from "../Theme";

const globalStyles = {
  "*": {
    padding: 0,
    margin: 0,
    boxSizing: "border-box",
  },
  html: {
    fontFamily: "'Outfit', sans-serif",
    fontSize: "62.5%",
    textSizeAdjust: "100%",
    scrollBehavior: "smooth",
  },
  body: {
    textRendering: "optimizeSpeed",
  },

  // Scroll bar
  "html *::-webkit-scrollbar": {
    borderRadius: 0,
    width: "8px",
  },

  "html *::-webkit-scrollbar-thumb": {
    borderRadius: "4px",
    backgroundColor: theme.palette.primary.light,
  },

  "html *::-webkit-scrollbar-track": {
    borderRadius: 0,
    backgroundColor: "rgba(0, 0, 0, 0)",
  },

  "input:-webkit-autofill": {
    transition: `background-color 600000s 0s, color 600000s 0s`,
  },
  "input:-webkit-autofill:focus": {
    transition: `background-color 600000s 0s, color 600000s 0s`,
  },
  "input[data-autocompleted]": {
    backgroundColor: "transparent !important",
  },

  "@keyframes shaking": {
    "0%": { transform: " rotate(0deg)" },
    "25%": { transform: " rotate(10deg)" },
    "50%": { transform: " rotate(0eg)" },
    "75%": { transform: "rotate(-10deg)" },
    "100%": { transform: " rotate(0deg)" },
  },

  "@keyframes height-grow": {
    from: { transform: "scaleY(0)", maxHeight: 0, opacity: 0 },
    to: { transform: "scaleY(1)", maxHeight: "100px", opacity: 1 },
  },

  ".MuiPickersCalendarHeader-labelContainer": {
    fontSize: "1.6rem !important",
  },
  ".MuiDayCalendar-header": {
    span: {
      fontSize: "1.4rem !important",
    },
  },

  ".MuiDayCalendar-monthContainer, .MuiYearCalendar-root": {
    button: {
      fontSize: "1.4rem !important",
    },
  },
};

interface GlobalStylesProps {}

const GlobalStyles: FC<GlobalStylesProps> = () => {
  return <MGlobalStyles styles={globalStyles} />;
};

export default GlobalStyles;
